import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function displaySwitch(theme: Theme): ComponentStyle {
  return {
    componentName: 'displaySwitch',
    baseStyle: {
      width: 'fit-content',
      backgroundColor: theme.colors.foreground,
      borderRadius: theme.sizes['-5'],
      padding: theme.space['4xs']
    }
  };
}
